import TaskType from '../Models/TaskType';
import DataGridRequest from './DataGridRequest';
export class UrlsRequest extends DataGridRequest<TaskType> {
    Url = 'urls/api';
}
